export default __webpack_public_path__ + "static/media/logout.5f1b7d83.svg";